import Core from "@/modules/core/service/Core";
import Msd from "@/modules/msd/common/service/Msd";

const url = {
    init     : "/api/contract/company",
    contracts: "/api/contract/company/{0}",
    contract : "/api/contract/{0}",
    unit     : "/api/contract/{0}/unit/{1}",
    assign   : "/api/contract/{0}/assign/{1}",
    dissolve : "/api/contract/{0}/dissolve/{1}",
    history  : "/api/contract/unit/{0}?type={1}",
    renew    : "/api/contract/renew"
};

export default {
    enums: {
        toc : {
            mounths  : 1,
            quarters : 2,
            halfyears: 3,
            years    : 4,
            fix      : 5,
            special  : 6,
            contractend: 7
        },

        renewal : {
            months  : 1,
            quarters: 2,
            years   : 3
        },

        types: {
            lim: 1,
            dls: 2,
            mnt: 3,
            esc: 4,
            zus: 5,
        }
    },

    findById (contractId, success) {
        Core.method.get(url.contract, contractId).then((data) => success (data));
    },

    list(company, filter, success) {
        return Core.method.post(url.contracts, filter, company).then(data => success (data));
    },

    create (customerId, companyId, typeId, success) {
        Core.method.post(url.init, {
            customerId,
            companyId,
            typeId
        }).then ((data) => success(data));
    },

    save (contract, success) {
        return Core.method.put(url.contract, contract, contract.id).then (data => success(data));
    },

    unit: {
        history (unitId, typeId) {
            return Core.method.get(url.history, unitId, typeId);
        },

        saveLim (unitId, contractId,  contract) {
            contract.clazz = "ContractLimUnitDto";
            return Core.method.put(url.unit, contract, contractId, unitId);
        },

        saveDls (unitId, contractId,  contract) {
            contract.clazz = "ContractDlsUnitDto";
            return Core.method.put(url.unit, contract, contractId, unitId);
        },

        saveMnt (unitId, contractId,  contract) {
            contract.clazz = "ContractMntUnitDto";
            return Core.method.put(url.unit, contract, contractId, unitId);
        },

        saveEsc (unitId, contractId,  contract) {
            contract.clazz = "ContractEscUnitDto";
            return Core.method.put(url.unit, contract, contractId, unitId);
        },

        saveZus (unitId, contractId,  contract) {
            contract.clazz = "ContractZusUnitDto";
            return Core.method.put(url.unit, contract, contractId, unitId);
        }
    },

    refresh (siteId) {
        return Core.method.get(Msd.url.sitesearch + "/" + siteId);
    },

    assign (contract, site) {
        return Core.method.postVoid(url.assign, null, contract.id, site.id);
    },

    dissolve (contract, siteId) {
        return Core.method.postVoid(url.dissolve, null, contract.id, siteId);
    },

    isAssigned (contract, unit) {
        // noinspection JSUnresolvedVariable
        return contract.id === unit.contractLimId || contract.id === unit.contractMntId || contract.id === unit.contractEscId || contract.id === unit.contractZusId;
    },

    findRenewals () {
        return Core.method.get(url.renew)
    },
} ;


